import React, { useState } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Home from './components/Home';
import CV from './components/CV';
import Login from './components/Login';
import Dashboard from './components/Dashboard';
import Navbar from './components/Navbar';
import ThemeToggle from './components/ThemeToggle';
import './App.css';

function App() {
  const [loggedIn, setLoggedIn] = useState(false);
  const [theme, setTheme] = useState('pink');

  const toggleTheme = () => {
    const nextTheme = theme === 'pink' ? 'blue' : theme === 'blue' ? 'green' : theme === 'green' ? 'purple' : 'pink';
    setTheme(nextTheme);
  };

  return (
    <div className={`App theme-${theme}`}>
      <Router>
        <Navbar loggedIn={loggedIn} setLoggedIn={setLoggedIn} />
        <ThemeToggle toggleTheme={toggleTheme} />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/cv" element={<CV />} />
          <Route path="/login" element={<Login onLogin={() => setLoggedIn(true)} />} />
          <Route path="/dashboard" element={loggedIn ? <Dashboard /> : <Navigate to="/login" />} />
        </Routes>
      </Router>
    </div>
  );
}

export default App;
